module.exports = __webpack_public_path__ + "img/FR13168.7377e0e6.png";